// extracted by mini-css-extract-plugin
module.exports = {"hotSearch":"hotSearch_hotSearch__ocVk_","title":"hotSearch_title__Wd06c","list":"hotSearch_list__Cl6ff","item":"hotSearch_item__qTkIU","link":"hotSearch_link__3wDyR"};